/*!
 *	Cliplister Content Integration Lib.
 *
 *	File:			cllib.inc.js
 *	Copyright by:           Cliplister GmbH
 *	Author: 		Cliplister GmbH
 *	Version:		2.5
 * 	lastChanges:            @Changelog.txt 
 *
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * -----------------------------------SPECAIL ADAPTION---------------------------------------
 *
 * default script: http://mycliplister.com/static/clplayer/cllib.inc.min.js
 *
 *	Normally this script waits on two events before it sends the request to the cliplister
 *	server. But because of our lazy loading these events (window.document.DOMContentLoaded
 *	and window.document.onload) are triggered before this script was loaded.
 *
 *  So we removed the document.onload event and replaced the document.DOMContentLoaded
 *  with a custom event(cliplister_load_config_finished_event).
 *  Now we can create a player first and then trigger the event which starts the cliplister
 *  logic.
 *  This is executed in jquery.shopgate-product-details-cliplister.js from line 64 to line 94
 *
 * changes line 227
 * from:
 * }, n.Cliplister = n.CL = c(), n.Clip = l, i.addEventListener ? i.addEventListener("DOMContentLoaded", function () {
 *	  n.Cliplister.addLoadEvent(function () {
 *    	i.removeEventListener("DOMContentLoaded", arguments.callee, !1), n.Cliplister.clips.length > 0 && n.Cliplister.onReadyBuildHTML()
 *	  })
 * to:
 * }, n.Cliplister = n.CL = c(), n.Clip = l, i.addEventListener ? i.addEventListener("cliplister_load_config_finished_event", function () {
 *		i.removeEventListener("cliplister_load_config_finished_event", arguments.callee, !1), n.Cliplister.clips.length > 0 && n.Cliplister.onReadyBuildHTML()
 *
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */
(function (n, t) {
	function l(n) {
		return new Object(n)
	}

	if (n.Cliplister === t) {
		var c = function () {
			return new e
		}, u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", e = function () {
		}, i = n.document, h = "mycliplister.com/cliplister/";
		var s = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, r, o, a = {
			"\b": "\\b",
			"\t": "\\t",
			"\n": "\\n",
			"\f": "\\f",
			"\r": "\\r",
			'"': '\\"',
			"\\": "\\\\"
		}, f;
		e.prototype = {
			clips: [], tmplist: [], request: {}, log: [], config: {shopId: 0, SEO: !1, autoplay: !1, callbacks: {}}, setID: function (n) {
				this.setshopId(n)
			}, setshopId: function (n) {
				this.config.shopId = n
			}, setSEO: function (n) {
				this.config.SEO = n
			}, setAutoplay: function (n) {
				this.config.autoplay = n
			}, player: function () {
				for (var n = 0; n < this.player.arguments.length; n++)switch (this.clTypeOf(this.player.arguments[n])) {
					case"string":
						this.setID(this.player.arguments[n]);
						break;
					case"number":
						this.setID(this.player.arguments[n]);
						break;
					case"boolean":
						this.setSEO(this.player.arguments[n]);
						break;
					default:
						this.addClip(this.player.arguments[n])
				}
			}, onReadyBuildHTML: function () {
				this.config.shopId === 0 && this.readshopId(), this.readAutoplay(), this.readSEO(), this.addSEO(), this.addshopId();
				for (var n = 0; n < this.clips.length; n++)this.clips[n].timer = (new Date).getTime();
				this.buildRequest()
			}, readshopId: function () {
				for (var n = 0; n < this.clips.length; n++)if (this.clips[n].shopId !== t) {
					this.config.shopId = this.clips[n].shopId;
					break
				}
			}, getCallback: function (n) {
				return this.config.callbacks[n]
			}, readSEO: function () {
				for (var n = 0; n < this.clips.length; n++)if (this.clips[n].SEO !== t) {
					this.setSEO(this.clips[n].SEO);
					break
				}
			}, readAutoplay: function () {
				for (var n = 0; n < this.clips.length; n++)if (this.clips[n].autoplay !== t) {
					this.setAutoplay(this.clips[n].autoplay);
					break
				}
			}, addshopId: function () {
				for (var n = 0; n < this.clips.length; n++)this.clips[n].shopId = this.config.shopId
			}, addSEO: function () {
				for (var n = 0; n < this.clips.length; n++)this.clips[n].SEO = this.config.SEO
			}, addClip: function (n) {
				this.clTypeOf(n) === "array" ? this.clips = this.clips.concat(n) : this.clTypeOf(n) === "object" && this.clips.push(n)
			}, checkVideoAvailability: function (n) {
				var t = new Image, i;
				t.onload = function () {
					t.width < 2 && (n.style.height = "0", n.style.width = "0", n.style.visibility = "hidden")
				}, i = n.src.replace(/\/ind/g, ""), t.src = i.replace(/\?.*/g, "") + "/cx"
			}, JSONstringify: function (n, t, i) {
				var u;
				if (r = "", o = "", typeof i == "number")for (u = 0; u < i; u += 1)o += " "; else typeof i == "string" && (o = i);
				if (f = t, t && typeof t != "function" && (typeof t != "object" || typeof t.length != "number"))throw new Error("this.JSONstringify");
				return this.JSONstr("", {"": n})
			}, JSONstr: function (n, t) {
				var u, h, e, c, l = r, s, i = t[n];
				typeof f == "function" && (i = f.call(t, n, i));
				switch (typeof i) {
					case"string":
						return this.JSONquote(i);
					case"number":
						return isFinite(i) ? String(i) : "null";
					case"boolean":
					case"null":
						return String(i);
					case"object":
						if (!i)return "null";
						if (r += o, s = [], Object.prototype.toString.apply(i) === "[object Array]") {
							for (c = i.length, u = 0; u < c; u += 1)s[u] = this.JSONstr(u, i) || "null";
							return e = s.length === 0 ? "[]" : r ? "[\n" + r + s.join(",\n" + r) + "\n" + l + "]" : "[" + s.join(",") + "]", r = l, e
						}
						if (f && typeof f == "object")for (c = f.length, u = 0; u < c; u += 1)typeof f[u] == "string" && (h = f[u], e = this.JSONstr(h, i), e && s.push(this.JSONquote(h) + (r ? ": " : ":") + e)); else for (h in i)Object.prototype.hasOwnProperty.call(i, h) && (e = this.JSONstr(h, i), e && s.push(this.JSONquote(h) + (r ? ": " : ":") + e));
						return e = s.length === 0 ? "{}" : r ? "{\n" + r + s.join(",\n" + r) + "\n" + l + "}" : "{" + s.join(",") + "}", r = l, e
				}
			}, JSONquote: function (n) {
				return s.lastIndex = 0, s.test(n) ? '"' + n.replace(s, function (n) {
					var t = a[n];
					return typeof t == "string" ? t : "\\u" + ("0000" + n.charCodeAt(0).toString(16)).slice(-4)
				}) + '"' : '"' + n.replace(/[\u00A0-\u2666<>\&]/g, function (n) {
					return "&#" + n.charCodeAt(0) + ";"
				}) + '"'
			}, clTypeOf: function (n) {
				return typeof n == "object" ? n.length ? "array" : "object" : typeof n
			}, getHTML: function (r, f, e) {
				var o = this.clips[r].playerID, s, c, l;
				o || (o = e ? e : "Cliplister_" + this.getRandom(100, 999999999999), this.clips[r].playerID = o), this.clips[r].onReady && typeof this.clips[r].onReady == "function" && (this.config.callbacks[o] = this.clips[r].onReady);
				var p = this.clips[r].urlPattern !== t ? this.clips[r].urlPattern : "lcplay", w = this.config.autoplay !== t ? this.config.autoplay : "false", a = "";
				if (this.clips[r].param !== t)for (s in this.clips[r].param)a += "&" + s + "=" + encodeURIComponent(this.clips[r].param[s]);
				var v = this.clips[r].geo, y = n.location.protocol + "//" + (v ? v + "." : "") + h + p + u.charAt(63) + this.clips[r].shopId + u.charAt(63) + this.clips[r].request + "?id=" + o + "&autoplay=" + w + a, b = this.clips[r].seoString !== t ? this.clips[r].seoString : "";
				this.clips[r].request && (i.getElementById(o) || (c = i.createElement("div"), c.id = o, f.appendChild(c)), typeof this.clips[r].indirect == "boolean" && this.clips[r].indirect ? (l = n.Cliplister.clips[r].size.split("x"), i.getElementById(o).innerHTML += '<iframe width="' + l[0] + '" height="' + l[1] + '" src="' + y + '" frameborder="0" onload="javascript:Cliplister.checkVideoAvailability(this)" scrolling="no"><\/iframe>') : this.ajax(y, !0, this.setupResponse, r))
			}, setupResponse: function (n, r) {
				if (typeof n !== t) {
					e.clips[r].response = n;
					try {
						eval(n.responseText + "")
					} catch (f) {
						if (n.responseText.replace(/^[\s\xA0]+/, "").replace(/[\s\xA0]+$/, "").match("^<")) {
							var u = n.responseText;
							u.replace(/\ /g, "").match("position:absolute;") && (u = u.replace(/ style=\"([a-z:0-9;]*)\"/g, "")), i.getElementById(e.clips[r].playerID).innerHTML += u
						}
					}
				}
			}, buildRequest: function () {
				for (var r = 0, i = 0; i < this.clips.length; i++)this.request[i] = !0, this.clips[i] && !this.clips[i].response && this.config.shopId && (this.request[i] = !1, this.ajax(n.location.protocol + "//" + h + "lc" + u.charAt(63) + this.config.shopId + u.charAt(63) + "?" + this.encode(this.JSONstringify([this.clips[i]])), !0, function (i, r) {
					var u, f, o;
					e = n.Cliplister;
					try {
						u = eval("(" + i.responseText + ")"), n.Cliplister.clips[r] = Object.deepExtend(n.Cliplister.clips[r], u != t ? u[0] : []), n.Cliplister.tmplist.length > 0 && (n.Cliplister.clips = n.Cliplister.tmplist.concat(n.Cliplister.clips), n.Cliplister.tmplist = []), n.Cliplister.request[r] = !0, f = !0;
						for (o in n.Cliplister.request)n.Cliplister.request[o] || (f = !1);
						f && n.Cliplister.setupClipBuild()
					} catch (s) {
					}
				}, i), r++);
				r == 0 && this.setupClipBuild()
			}, reloadClips: function () {
				for (var n, t = 0; t < this.clips.length; t++)if (n = i.getElementById(this.clips[t].playerID), n)while (n.hasChildNodes())n.removeChild(n.firstChild);
				this.onReadyBuildHTML()
			}, setupClipBuild: function () {
				for (var r, n = 0; n < this.clips.length; n++)this.clips[n].elementID !== t && (r = i.getElementById(this.clips[n].elementID), r && this.getHTML(n, r))
			}, getRandom: function (n, t) {
				if (n > t)return -1;
				if (n == t)return n;
				var i;
				do i = Math.random(); while (i == 1);
				return n + parseInt(i * (t - n + 1))
			}, ajax: function (t, i, r, u) {
				var f = null;
				!n.XDomainRequest && n.XMLHttpRequest ? (f = new XMLHttpRequest, f.open("GET", t, i), f.timeout = 5e3, f.onreadystatechange = function () {
					f.readyState == 4 && (f.status == 200 && f.responseText != "" ? r(f, u) : f.abort())
				}) : (f = new XDomainRequest, f.timeout = 5e3, f.onload = function () {
					r(f, u)
				}, f.onprogress = function () {
				}, f.ontimeout = function () {
				}, f.onerror = function () {
				}, f.open("GET", t)), n.setTimeout(function () {
					f.send()
				}, 0)
			}, ajaxPOST: function (t, i, r, u, f) {
				var e = null;
				!n.XDomainRequest && n.XMLHttpRequest ? (e = new XMLHttpRequest, e.open("POST", t, r), e.timeout = 5e3, e.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), e.onreadystatechange = function () {
					e.readyState == 4 && e.status == 200 && e.responseText != "" && u(e, f)
				}) : (e = new XDomainRequest, e.timeout = 5e3, e.onload = function () {
					u(e, f)
				}, e.onprogress = function () {
				}, e.ontimeout = function () {
				}, e.onerror = function () {
				}, e.open("POST", t)), n.setTimeout(function () {
					e.send("cldata=" + i)
				}, 0)
			}, loadJS: function (n, r) {
				var e = i.getElementsByTagName("HEAD").item(0), u = i.createElement("script"), f = !1;
				u.language = "javascript", u.type = "text/javascript", typeof r === t && (r = function () {
				}), u.onreadystatechange = u.onload = function () {
					f || this.readyState && !/loaded|complete/.test(this.readyState) || (f = !0, r())
				}, u.src = n, e.appendChild(u)
			}, encode: function (n) {
				n = escape(n);
				var s = "", f, t, i = "", h, c, e, r = "", o = 0;
				do f = n.charCodeAt(o++), t = n.charCodeAt(o++), i = n.charCodeAt(o++), h = f >> 2, c = (f & 3) << 4 | t >> 4, e = (t & 15) << 2 | i >> 6, r = i & 63, isNaN(t) ? e = r = 64 : isNaN(i) && (r = 64), s = s + u.charAt(h) + u.charAt(c) + u.charAt(e) + u.charAt(r), f = t = i = "", h = c = e = r = ""; while (o < n.length);
				return s
			}, decode: function (n) {
				var t = "", o, s, h = "", c, f, i, e = "", r = 0;
				/[^A-Za-z0-9\+\/\=]/g.exec(n), n = n.replace(/[^A-Za-z0-9\+\/\=]/g, "");
				do c = u.indexOf(n.charAt(r++)), f = u.indexOf(n.charAt(r++)), i = u.indexOf(n.charAt(r++)), e = u.indexOf(n.charAt(r++)), o = c << 2 | f >> 4, s = (f & 15) << 4 | i >> 2, h = (i & 3) << 6 | e, t = t + String.fromCharCode(o), i !== 64 && (t = t + String.fromCharCode(s)), e !== 64 && (t = t + String.fromCharCode(h)), o = s = h = "", c = f = i = e = ""; while (r < n.length);
				return unescape(t)
			}, addLoadEvent: function (t) {
				var i = n.onload;
				n.onload = typeof n.onload != "function" ? t : function () {
					try {
						i()
					} catch (n) {
					}
					t()
				}
			}
		}, n.Cliplister = n.CL = c(), n.Clip = l, i.addEventListener ? i.addEventListener("cliplister_load_config_finished_event", function () {
			i.removeEventListener("cliplister_load_config_finished_event", arguments.callee, !1), n.Cliplister.clips.length > 0 && n.Cliplister.onReadyBuildHTML()
		}, !1) : i.attachEvent && i.attachEvent("onreadystatechange", function () {
			(i.readyState === "complete" || i.readyState === "loaded") && n.Cliplister.addLoadEvent(function () {
				i.detachEvent("onreadystatechange", arguments.callee), n.Cliplister.clips.length > 0 && n.Cliplister.onReadyBuildHTML()
			})
		}), Object.isObjectLiteral = function (n) {
			return n && n.constructor && n.constructor === Object
		}, Object.deepExtend = function (n, t) {
			for (var i in t)Object.isObjectLiteral(n[i]) && Object.isObjectLiteral(t[i]) ? (n[i] = n[i] || {}, arguments.callee(n[i], t[i])) : n[i] = t[i];
			return n
		}
	}
})(window, undefined)


//////////////////
// WEBPACK FOOTER
// ./Library/1.0/vendor/cliplister-content_integration_lib.js
// module id = 430
// module chunks = 44